import React from 'react'
import ArticleButton from './article-button'

class ArticleList extends React.Component {
    constructor(props) {
        super(props)
        this.state={
            
        }
    }

    render() {
        const result = this.props.results.map( result =>
            <ArticleButton
              key={result._id}
              {...result}
            />
          )
        return(
            <div className='result-list'>
                {result}
            </div>
        )
    }
}

export default ArticleList